import { render, staticRenderFns } from "./EditarAlertaBaseModal.vue?vue&type=template&id=bc76facc&"
import script from "./EditarAlertaBaseModal.vue?vue&type=script&lang=ts&"
export * from "./EditarAlertaBaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bc76facc', component.options)
    } else {
      api.reload('bc76facc', component.options)
    }
    module.hot.accept("./EditarAlertaBaseModal.vue?vue&type=template&id=bc76facc&", function () {
      api.rerender('bc76facc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/EditarAlertaBaseModal.vue"
export default component.exports